/**
 * Temporary Material Symbols restore for CRM 2.0 (SPA + widgets).
 *
 * inhabit-uds-tokens dropped the Google Fonts @import and the
 * `.material-symbols-outlined` class. Ligature spans in this app still need
 * both. Import once from main.tsx or widget bootstrap; it is a no-op if
 * already injected.
 *
 * TODO(UDS-canary): Remove this module (and its imports from main.tsx /
 * widgetBootstrap / widget entries) when inhabit-uds-tokens restores Material
 * Symbols in `css/fonts`. After that, migrate remaining ligature spans to
 * `udc-icon`.
 */
const FONT_LINK_ID = 'crm2-material-symbols-font';
const STYLE_ID = 'crm2-material-symbols';
const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,400,0..1,0&display=swap';

const ICON_CLASS_CSS = `
.material-symbols-outlined {
  font-family: 'Material Symbols Outlined';
  font-weight: normal;
  font-style: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 20;
}
`;

export function injectMaterialSymbols(): void {
  if (typeof document === 'undefined') return;

  if (!document.getElementById(FONT_LINK_ID)) {
    const link = document.createElement('link');
    link.id = FONT_LINK_ID;
    link.rel = 'stylesheet';
    link.href = FONT_HREF;
    document.head.appendChild(link);
  }

  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = ICON_CLASS_CSS;
    document.head.appendChild(style);
  }
}

injectMaterialSymbols();
